module.exports = __webpack_public_path__ + "static/assets/f2e2ba40df81eb418759e8494d51dba4.png";